import React, { useRef, useState } from "react";

const videos = [
  {
    src: "https://www.youtube.com/embed/GLwygGvZPKo",
    title: "Welcome address",
    caption: "Welcome address by Course Directors & Course Highlights.",
  },
  {
    src: "https://www.youtube.com/embed/GLwygGvZPKo",
    title: "Launch of Boston Structural Heart",
    caption: "Launch of Boston Structural Heart by Feroze Mahmood MD FASE.",
  },
];

const AboutUs = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const index = Math.round(el.scrollLeft / el.offsetWidth);
    setActiveIndex(index);
  };

  const scrollTo = (index) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ left: el.offsetWidth * index, behavior: "smooth" });
    setActiveIndex(index);
  };

  return (
    <section id="about">
      <div className="mt-5">
        <div className="row">
          <div className="col-lg-8 px-5 text-left text-lg-start wow fadeInUp ">
            <div className="about-section offset-lg-1">
              <h2 className="text-8 fw-4oo mb-3">
                <span className="fw-700 border-3 border-primary text-primary">
                  About
                </span>
              </h2>
              <br></br>
              <br></br>
              <p
                className="text-5 text-justify"
                style={{
                  fontFamily: "Poppins",
                  fontWeight: "400px",
                }}
              >
                This is a first of its kind live virtual CME event, specifically
                designed to cover all major aspects of structural heart disease
                (SHD) imaging from basics to advance levels.
                <br />
                <br />
                Lectures by our esteemed faculty will be live-streamed followed
                by interactive panel discussions and the audience will get ample
                opportunity to pose their questions to the experts. We have
                adopted state of the art presentation style to comprehensively
                deliver difficult concepts in SHD imaging which includes but not
                limited to multiplanar reconstruction, 3D echocardiography,
                complex and challenging pathologies etc.
                <br />
                <br />
                The topics covered in this course will not only be a bootcamp
                for fellows-in-training but will also serve as a refresher of
                key concepts for trained clinicians with an opportunity to learn
                advance techniques and latest guidelines.
                <br />
                <br />A detailed discussion on ideal workflow and team mechanism
                during SHD interventions, challenges and solutions to training
                programs and future directions will create leaders in the field.
              </p>
            </div>
          </div>
          <div className="col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-6 d-flex justify-content-center about-icons" style={{ position: "relative" }}>
                <img width={100} height={100} src="images/images/Icons/2.png" alt="icon" />
              </div>
              <div className="col-lg-6 col-md-6 col-6 d-flex justify-content-center about-icons" style={{ position: "relative" }}>
                <img width={100} height={100} src="images/images/Icons/3.png" alt="icon" />
              </div>
              <div className="col-lg-6 col-md-6 col-6 d-flex justify-content-center about-icons" style={{ position: "relative" }}>
                <img width={100} height={100} src="images/images/Icons/4.png" alt="icon" />
              </div>
              <div className="col-lg-6 col-md-6 col-6 d-flex justify-content-center about-icons" style={{ position: "relative" }}>
                <img width={100} height={100} src="images/images/Icons/1.png" alt="icon" />
              </div>
            </div>
            <div className="video-scroller-container mb-4">
              <div
                className="video-scroll-wrapper"
                ref={scrollRef}
                onScroll={handleScroll}
              >
                {videos.map((v, i) => (
                  <div className="video-card video-scroll-item" key={i}>
                    <div className="video-ratio">
                      <iframe
                        allowFullScreen
                        title={v.title}
                        src={v.src}
                      ></iframe>
                    </div>
                    <p className="video-caption">{v.caption}</p>
                  </div>
                ))}
              </div>
              <div className="video-dots d-lg-none">
                {videos.map((_, i) => (
                  <button
                    key={i}
                    className={`video-dot${activeIndex === i ? " active" : ""}`}
                    onClick={() => scrollTo(i)}
                    aria-label={`Go to video ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
